/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import PreviewButton from "../../../components/Preview/PreviewButton";

import { ProductUnion } from "../../../types/ProductUnion";
import { LitigationUnion } from "../../../types/LitigationUnion";

export const previewCaseRejectedMessageButton = (
  product: LitigationUnion,
  template: string = "message/litigationCase/case-rejected"
) => {
  return (
    <PreviewButton
      key={"previewCaseRejectedMessage"}
      product={product}
      documentType={"message"}
      documentIdentifier={template}
      buttonText={"Vorschau Für Nachricht"}
      modalHeadline={"Vorschau Nachricht"}
    />
  );
};

export const previewClaimLetterButton = (product: ProductUnion) => {
  return (
    <PreviewButton
      key={"preview-extrajudicialLetter"}
      product={product}
      documentType={"pdf"}
      documentIdentifier={"extrajudicialLetter"}
      buttonText={"Vorschau für Schreiben"}
      modalHeadline={"Vorschau außergerichtliches Schreiben"}
    />
  );
};

export const previewFeedbackMessageButton = (
  product: LitigationUnion,
  template: string = "message/contractLaw/feedback"
) => {
  return (
    <PreviewButton
      key={"preview-feedbackMessage"}
      product={product}
      documentType={"message"}
      documentIdentifier={template}
      buttonText={"Vorschau für Feedback"}
      modalHeadline={"Vorschau Feedback Nachricht"}
    />
  );
};
